// extracted by mini-css-extract-plugin
export default {"root":"ZwjFeZiH","fade-in":"gyjZUvbM"};